import { render, staticRenderFns } from "./ReleasesSong.vue?vue&type=template&id=4d2e6c06"
import script from "./ReleasesSong.vue?vue&type=script&lang=js"
export * from "./ReleasesSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports